/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M8 0C6.067 0 4.5 1.567 4.5 3.5V4H2.4364a1 1 0 0 0-.9908.8649L.2368 13.7298C.073 14.9306 1.0065 16 2.2184 16h11.5632c1.2119 0 2.1454-1.0694 1.9816-2.2702l-1.2088-8.865A1 1 0 0 0 13.5636 4H11.5v-.5C11.5 1.567 9.933 0 8 0Zm2.5 5v1.5a.5.5 0 0 0 1 0V5h2.0636l1.2088 8.8649c.0819.6004-.3848 1.1351-.9908 1.1351H2.2184c-.606 0-1.0727-.5347-.9908-1.1351L2.4364 5H4.5v1.5a.5.5 0 1 0 1 0V5h5Zm0-1v-.5C10.5 2.1193 9.3807 1 8 1S5.5 2.1193 5.5 3.5V4h5Z"
    clipRule="evenodd"
  />,
  'MarketPlace'
);
